module.exports = __webpack_public_path__ + "img/image_cover.05ae713a.png";